module.exports = __webpack_public_path__ + "static/img/5.ad076d3d.jpg";